import httpManager from "../../util/common";
import {toThousands} from '../../util/util';
export default {
  data() {
    return {
      file: null,
      loading: false,
      download_file: '/documents/保险ESG_样本数据.xlsx',
      download_file_name: '保险ESG_样本数据.xlsx',
      formDatas: null, // 表格总数据
      formData: null, // 表格分页后每一页的数据
      risk_upload_show: false, // ?内容是否显示
      time_key: true, // setTimeInfo中用到的开关，如果为真,执行定时器内函数
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'center',
        pageSizes: [10, 20, 50, 100, 200, 500],
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true,
        pagerCount: 3
      },
      exportConfig: {},
    }
  },
  methods: {
    turnToReport() {
      if(this.formDatas) this.$router.push('insuranceesgreport')
      else alert('请先上传数据')
    },
    getFormData () {
      let self = this
      self.loading = true
      let data = new FormData() // FormData 对象
      data.append('file', this.file) // 文件对象
      httpManager('esg_risk', null, data)
        .then(response => {
          self.formDatas = JSON.parse(response.data.data.uploaddata)
          window.sessionStorage.setItem('esg_risk', JSON.stringify(response.data.data))
          this.setPage()
          self.loading = false
        })
        .catch(error => {
          console.log(error)
          self.loading = false
        })
    },
    // 上传本地文件
    clickLoad () {
      this.$refs.refFile.click()
    },
    fileLoad (e) {
      this.file = this.$refs.refFile.files[0]
      this.getFormData()
      e.target.value = ''
    },

    setPage() {
      // 进行分页的操作
      this.page.total = this.formDatas.length
      this.formData = this.formDatas.slice((this.page.currentPage - 1)*this.page.pageSize,this.page.currentPage*this.page.pageSize)
    },
    pageChange ({ currentPage, pageSize }) {
      // 页数切换
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.setPage()
    },
    // 离开问号后使其延时关闭
    setInfoTime() {
      setTimeout(()=>{
        if (this.time_key) this.risk_upload_show=false
      },500)
    },
    infoDivMouseEnter() {
      this.time_key=false
    },
    infoDivMouseMove() {
      this.risk_upload_show=false
      this.time_key = true
    }
  },
  created() {
    if(window.sessionStorage.getItem('esg_risk')){
      var k = JSON.parse(window.sessionStorage.getItem('esg_risk'))
      this.formDatas = JSON.parse(k.uploaddata)
      this.setPage()
    }
  },
  computed: {
    tableColumns() {
      return [
        { field: 'insurance_num', title: this.$t('insurance.policy_id'), width: 100 },
        { field: 'policy_holder', title: this.$t('insurance.insured_company_name') },
        { field: 'industry', title: this.$t('common.company_industry') },
        { field: 'region', title: this.$t('common.company_operating_region') },
        { field: 'insurance_type', title: this.$t('insurance.insurance_type') },
        { field: 'insurance_fee', title: this.$t('insurance.insurance_cost'), formatter: ({cellValue})=>{
          return toThousands(cellValue)
          } },
        { field: 'pay_limit', title: this.$t('insurance.compensation_limit'), formatter: ({cellValue})=>{
          return toThousands(cellValue)
          }},
        { field: 'insurance_start', title: this.$t('insurance.insurance_start'), showOverflow: true,
          formatter: ({cellValue})=>{
            var date = new Date(cellValue)
            return date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate()
          }},
        { field: 'insurance_end', title: this.$t('insurance.insurance_end'), showOverflow: true,
          formatter: ({cellValue})=>{
            var date = new Date(cellValue)
            return date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate()
          }},
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/insurance_esg/js/insurance_esg_upload.js